import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import './Vision.css';

export default function Vision() {
  const { t } = useLanguage();

  return (
    <section className="section section--dark vision">
      <div className="container vision__inner">
        <span className="kicker">{t.vision.kicker}</span>
        <p className="vision__text">{t.vision.text}</p>
      </div>
    </section>
  );
}
